module.exports = {"131002001":"银河南路街道","131002002":"光明西道街道","131002003":"永华道街道","131002100":"落垡镇","131002101":"码头镇","131002102":"葛渔城镇","131002103":"东沽港镇","131002200":"杨税务乡","131002201":"仇庄乡","131002202":"调河头乡","131002203":"北史家务乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131002.json
// module id = 206
// module chunks = 0